import service from "./service"
import mock from "./mock"

const requestPaperForm = async (data) => {
    //return mock()
    return service(data)
}

export default requestPaperForm
